import React, { ComponentProps } from 'react';
import { ProfileImage } from '../../../types/api/ImageType';
import { asView, useFetchUrl } from '../../../_lib/ViewFetcher';
import { Image, ImageModifier } from '../../../components/molecules/Image';

type PortalAvatarDefaultProps = {
  image: ProfileImage;
};
export function PortalAvatarDefault({ image }: PortalAvatarDefaultProps) {
  const fetchUrl = useFetchUrl();
  return <Image key={image.src} image={image} lazyLoading fetchUrl={fetchUrl} modifier={ImageModifier.WIDTH_AUTO} />;
}
export const PortalAvatarDefaultView = asView(PortalAvatarDefault);
export type PortalAvatarDefaultView = ComponentProps<typeof PortalAvatarDefaultView>;
